import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=313bb734&scoped=true&"
import script from "./Navbar.vue?vue&type=script&lang=js&"
export * from "./Navbar.vue?vue&type=script&lang=js&"
import style0 from "./Navbar.vue?vue&type=style&index=0&id=313bb734&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313bb734",
  null
  
)

/* custom blocks */
import block0 from "./Navbar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('313bb734')) {
      api.createRecord('313bb734', component.options)
    } else {
      api.reload('313bb734', component.options)
    }
    module.hot.accept("./Navbar.vue?vue&type=template&id=313bb734&scoped=true&", function () {
      api.rerender('313bb734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/Navbar.vue"
export default component.exports